<template>
  <div>
    <div class="contain intro">
      <div class="text">
        <h1>
          Inroduction to
          <br />
          {{kiosk.contentTitle}}
        </h1>
        <button class="btn" @click="$emit('show-page')">EXPLORE NOW</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["kiosk"]
};
</script>

<style lang='scss'>
.intro .text {
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  top: 0;
  h1 {
    margin-bottom: 75px;
  }
}
</style>